import React from 'react';

import {
  SearchIcon,
  PinIcon,
  HouseIcon,
  SettlementIcon,
  StreetIcon,
  MapIcon,
  AirportIcon,
  TrainIcon,
} from '../../../assets/icons';
import type { GeocodeResult } from '../../api/types';

export { SearchIcon };

const POI_LABEL_ICON: Record<string, React.ReactNode> = {
  аэропорт: <AirportIcon />,
  'ж/д вокзал': <TrainIcon />,
};

export function getResultIcon(item: GeocodeResult): React.ReactNode {
  if (item.precision === 'poi') {
    const poiLabel = item.hierarchy[item.hierarchy.length - 1]?.short;

    return (poiLabel && POI_LABEL_ICON[poiLabel]) ?? <PinIcon />;
  }

  switch (item.precision) {
    case 'house':
      return <HouseIcon />;
    case 'street':
      return <StreetIcon />;
    case 'city':
      return <PinIcon />;
    case 'locality':
      return isResidentialTerritory(item) ? <SettlementIcon /> : <PinIcon />;
    case 'area':
    case 'region':
      return <MapIcon />;
    default:
      return <PinIcon />;
  }
}

function isResidentialTerritory(item: GeocodeResult): boolean {
  const node = item.hierarchy[item.hierarchy.length - 1];
  if (!node || node.level !== 7) return false;

  const type = node.short.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ').trim();
  const label = `${type} ${node.name}`.toLowerCase().replace(/ё/g, 'е');
  if (/(^|\s)(гск|гараж\S*|промзона|промышленн\S*)(?=\s|$)/u.test(label)) return false;

  return /(^|\s)(кп|снт|снп|днп|днт|тсн|тсж|ст)(?=\s|$)/u.test(label) ||
    /коттеджный\s+поселок/u.test(label) ||
    ['тер', 'территория', 'мкр', 'микрорайон', 'жилой район'].includes(type);
}
